export default function DecoratorPage() {
  return <>Decorator:</>;
}
